import SkillDto from '@/models/Skills/SkillDto';
import UniformDto from '@/models/Uniforms/UniformDto';
import DeskDto from '@/models/Desks/DeskDto';
import IndustryDto from '@/models/Industries/IndustryDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import QualificationDto from '@/models/Qualifications/QualificationDto';


export default class PositionDto extends BaseAgencyScopeEntityDto {
    status = 90;
    code = '';
    name = '';
    description = '';
    minimumHours = 4;
    industryId = '';
    industry: IndustryDto = new IndustryDto();
    skills: SkillDto[] = [];
    qualifications: QualificationDto[] = [];
    uniforms: UniformDto[] = [];
}